import React from "react";
import PropertyForm from "@/pages/PropertyForm";
import { useSeo } from "@/lib/seo";

export default function Pubblica() {
    useSeo({ title: "Pubblica il tuo annuncio immobiliare | VendiDirect", description: "Pubblica casa in pochi minuti: foto con watermark, descrizione generata dall'AI, indirizzo protetto e contatti visibili solo agli utenti abbonati.", canonical: "/pubblica" });
    return <PropertyForm mode="create" />;
}
